import { useTranslation } from "react-i18next";
import { LANGUAGE_OPTIONS } from "@/locales";
import { Dropdown } from "@/components/ui/modal";

export function LanguageForm() {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium text-i-normal">
          {t("settings_account.language_form.language")}
        </label>
        <Dropdown
          value={i18n.language}
          options={LANGUAGE_OPTIONS}
          onValueChange={handleLanguageChange}
          width="10rem"
          className="text-sm"
        />
      </div>
    </div>
  );
}
